import { Controller } from '@hotwired/stimulus'
import * as analytics from '../utils/analytics'

export default class extends Controller {
  static get targets () {
    return ['ingredient']
  }

  connect () {
    if (window.xprops && window.xprops.version) {
      this.setupImpressionTracking()
    }
  }

  setupImpressionTracking () {
    this.defineParentEventHandler()

    window.xprops.onChildEvent({
      name: 'setup_impression_tracking'
    })
  }

  // dupe of code in bundle_embed_controller
  defineParentEventHandler () {
    window.xprops.export({
      onParentEvent: (event) => {
        switch (event.name) {
          case 'impression_detected':
            this.trackImpression()
            break
          default:
            console.warn('[Provenance] Unrecognised parent event:', event)
        }
      }
    })
  }

  trackImpression () {
    this.ingredientTargets.forEach(ingredient => {
      analytics.track('impression', {
        eventCategory: 'impression_ingredient_list',
        eventAction: ingredient.dataset.label,
        eventLabel: `${this.element.dataset.channel} / ${ingredient.dataset.context}`
      })
    })
  }
}
